import { Map } from 'immutable';
import actions from './actions';

const initState = new Map({
  success: false ,
  msg:'',
  result: [],
  exportresult: [],
  listresult:[],
  listsuccess:false,
  total_count: 0,
  labelfilter: [],
  grpfilter: [],
  page: 1,

});

export default function categoriesReducer(state = initState, action) {
 // console.log('action',action);
  switch (action.type) {
  case actions.CATEGORIES_LIST:
   return state.set('info', action.payload.info);
  case actions.CATEGORIES_LIST_RESULT:
  return state
    .set('exportresult', action.result)
    .set('result', action.result)
    .set('success', action.success)
    .set('total_count', action.total_count)
    .set('labelfilter', action.labelfilter)
    .set('grpfilter', action.grpfilter)
    .set('page', action.page);
  case actions.CATEGORIES_FETCH_LIST_ID:
  return state
   .set('result', action.result)
   .set('success', action.success);
    default:
      return state;
  }
  //return state;
}
